<div class="container">
  <h2 class="my-5">Food &amp; Dining</h2>

  <section class="row" id="restaurants">
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
    <div class="col-md-9">
      <h3>Restaurants</h3>
      <p>
        Taniti currently boasts 10 unique restaurants, each offering a distinct culinary experience that reflects both local traditions
        and international flavors. Five of these establishments specialize in fresh, locally sourced seafood paired with seasoned rice
        and tropical ingredients. Visitors can enjoy everything from grilled mahi-mahi to traditional island-style poke bowls, often
        served with sides of sweet plantains or tangy coconut slaw.
      </p>
      <p>
        For those craving the familiar comforts of home, three restaurants offer American-style fare, featuring classic burgers,
        grilled steaks, hearty breakfast platters, and crisp salads. These casual eateries are popular among families and travelers
        looking for a relaxed dining atmosphere with recognizable favorites.
      </p>
      <p>
        Rounding out the dining scene are two Pan-Asian restaurants, which bring a vibrant fusion of flavors to the island.
        Guests can savor dishes inspired by Thai, Japanese, Chinese, and Vietnamese cuisines, such as spicy curries, sushi rolls,
        stir-fried noodles, and savory dumplings.
      </p>
      <p>
        Whether you're in the mood for traditional island fare, a taste of home, or bold global flavors, Taniti's dining options offer
        something to satisfy every palate.
      </p>
    </div>
  </section>

  <hr class="my-5">


  <section class="row" id="supermarket">
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
    <div class="col-md-9">
      <h3>Supermarkets</h3>
      <p>
        Taniti is home to two full-service supermarkets that cater to both locals and visitors. These larger stores carry a
        wide selection of fresh produce, meat, dairy products, baked goods, and household essentials. Shoppers can find both
        local and imported brands, including organic options and specialty items for dietary needs. With spacious aisles,
        modern amenities, and convenient parking, the supermarkets on Taniti offer a comfortable and comprehensive shopping
        experience for those planning to stock up during their stay.
      </p>
    </div>
  </section>

  <hr class="my-5">


  <section class="row" id="groceries">
    <div class="col-md-9">
      <h3>Grocery Stores</h3>
      <p>
        In addition to supermarkets, Taniti features two smaller grocery stores scattered throughout the island. These
        stores often focus on everyday necessities and local products, offering fresh fruits, vegetables, bread, dry goods,
        and canned items. Many are family-owned and provide a more personal, community-oriented shopping experience. While
        selection may be more limited than in supermarkets, these stores are perfect for quick stops and offer a great
        opportunity to support local businesses.
      </p>
    </div>
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
  </section>


  <hr class="my-5">


  <section class="row" id="convenience">
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" height="200" class="rounded-3 aspect-1">
    </div>
    <div class="col-md-9">
      <h3>Convenience Stores</h3>
      <p>
        For travelers on the go, Taniti also has a convenience stores located in the heart of Taniti City near popular tourist areas, resorts,
        and transportation hubs. The shop is ideal for grabbing snacks, cold drinks, toiletries, or beach essentials like
        sunscreen and sunglasses. Open 24 hours a day, seven days a week, the convenience store offers fast, no-frills service for
        anyone needing something in a hurry or outside of regular business hours.
      </p>
    </div>
  </section>

  <hr class="my-5">


  <section class="row" id="pub_brewery">
    <div class="col-md-9">
      <h3>Pubs &amp; Breweries</h3>
      <p>
        Taniti's nightlife and social scene are enriched by a handful of welcoming pubs and a growing craft brewery presence.
        Local pubs offer a laid-back atmosphere where visitors can enjoy cold drinks, live music, and friendly conversation well
        into the evening. Many serve casual bar fare alongside island-inspired cocktails and a selection of regional rums. Taniti
        is also home to two small breweries that craft unique beers using tropical ingredients like passionfruit, coconut, and
        hibiscus. Brewery tours and tastings are popular with tourists looking to experience the island's flavor in a glass, making
        these spots a must-visit for beer enthusiasts.
      </p>
    </div>
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" height="200" class="rounded-3">
    </div>
  </section>
</div>
